import React from 'react';

// STYLES
import { Buttons, ModalWrapper } from 'view/CookieModule/CookieModuleStyled';

// MISC
import { TextType } from 'components/Atoms/CustomText/CustomTextModel';
import { COLORS } from 'constants/variables';
import useCookieConsent from '../../hooks/useCookieConsent';
import { ButtonType } from 'components/Atoms/ButtonAtom/ButtonAtomModel';
import { CookieConsentProps } from 'view/CookieModule/CookieModuleModel';
import { translations } from 'view/CookieModule/config/cookieModuleConfig';

// COMPONENTS
import CookiesPreferencesModal from '../CookiePreferencesModal/CookiesPreferencesModal';
import ButtonAtom from 'components/Atoms/ButtonAtom/ButtonAtom';
import CustomText from 'components/Atoms/CustomText/CustomText';

const CookieConsent: React.FC<CookieConsentProps> = ({
  language,
  necessaryCookies: initialNecessaryCookies,
  analyticsCookies: initialAnalyticsCookies,
}) => {

  const {
    isVisible,
    showModal,
    necessaryCookies,
    analyticsCookies,
    setNecessaryCookies,
    setAnalyticsCookies,
    handleAccept,
    handleSaveSettings,
    handleManageSettings,
    setShowModal,
  } = useCookieConsent(initialNecessaryCookies, initialAnalyticsCookies);
  const handleClosePreferencesModal = () => {
    setShowModal(false);
  };
  const t = translations[language];

  return (
    <>
      {isVisible && !showModal && (
        <ModalWrapper>
          <CustomText
            type={TextType.H3}
            text={t.consentTitle}
            color={COLORS.Orange}
          />
          <CustomText
            type={TextType.P2}
            text={t.consentText}
            color={COLORS.Cultured}
          />
          <Buttons>
            <ButtonAtom
              type={ButtonType.CookieButton}
              text={t.acceptButtonText}
              onClick={handleAccept}
            />
            <ButtonAtom
              type={ButtonType.ManagementButton}
              text={t.manageSettingsText}
              onClick={handleManageSettings}
            />
          </Buttons>
        </ModalWrapper>
      )}
      <CookiesPreferencesModal
        showModal={showModal}
        setShowModal={handleClosePreferencesModal}
        necessaryCookies={necessaryCookies}
        analyticsCookies={analyticsCookies}
        setNecessaryCookies={setNecessaryCookies}
        setAnalyticsCookies={setAnalyticsCookies}
        handleSaveSettings={handleSaveSettings}
        language={language}
      />
    </>
  );
};

export default CookieConsent;
